import { useParams } from "react-router-dom";

import { useRemoveUserFromWorkspace } from "../../../api/workspace";
import { useConfirm } from "../../../hooks/useConfirm";
import { DeleteAction } from "../../TableActions";
import { fullName } from "./AccountIdentity";

export default function RemoveUserModalButton({ user, workspaceName }) {
  const { id } = useParams();
  const { mutate } = useRemoveUserFromWorkspace({ workspaceId: id });
  const confirm = useConfirm();

  const name = fullName(user);

  const openModal = () =>
    confirm({
      title: "Remove from workspace",
      message: `Remove ${name} from ${workspaceName ?? "this workspace"}? They will no longer be able to manage its events.`,
      confirmLabel: "Remove",
      confirmColor: "red",
      onConfirm: () => mutate({ userId: user.id }),
    });

  return <DeleteAction label="Remove from workspace" onDelete={openModal} />;
}
